module.exports = __webpack_public_path__ + "static/media/upload-alt.712775f2.svg";